import { type CSSProperties } from 'react';

// Phase 5.X-validation-rules-tier-grouping —
// Shared cell padding/sizing used by both the RuleRow component's <td>s
// and the TierSection's <thead> column headers. Lifted into its own
// module so react-refresh's "only-export-components" rule stays happy
// (component files only export components).

export const ruleRowCellStyle: CSSProperties = {
  padding: '10px 8px',
  verticalAlign: 'top',
  fontSize: 13,
};
